<template>
  <div>
    <el-button
      v-if="hasAuth('sys:coupons:add')"
      style="margin-bottom: 20px"
      type="primary"
      @click="addUpdateCouponsButton(null)"
    >
      添加优惠券
    </el-button>
    <el-button
      v-if="hasAuth('sys:coupons:add')"
      style="margin-bottom: 20px"
      type="primary"
      @click="CouponsSetting(null)"
    >
      券可叠加数配置
    </el-button>
    <el-button
      style="margin-bottom: 20px"
      type="primary"
      @click="exportCouponsTemplate(null)"
    >
      导出模板
    </el-button>

    <el-upload
      ref="upload"
      :action="uploadUrl"
      :headers="uploadHeaders"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadError"
      :before-upload="beforeUpload"
      :show-file-list="false"
      accept=".xlsx,.xls"
      style="display: inline-block; margin-left: 10px"
    >
      <el-button style="margin-bottom: 20px" type="success">
        导入批量发放
      </el-button>
    </el-upload>

    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      :height="calcHeight"
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        align="center"
        label="ID"
        prop="id"
        width="80"
      ></el-table-column>
      <el-table-column
        align="center"
        label="券名称"
        prop="name"
        width="240"
      ></el-table-column>
      <el-table-column align="center" label="状态" prop="rulesType" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state === 0" size="small" type="danger">
            已下架
          </el-tag>
          <el-tag v-else-if="scope.row.state === 1" size="small" type="success">
            已上架
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="券类型"
        prop="waysObtain"
        width="160"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.waysObtain == 1" type="success">
            单笔消费满多少送
          </el-tag>
          <el-tag v-else-if="scope.row.waysObtain == 2" type="success">
            新用户注册
          </el-tag>
          <el-tag v-else-if="scope.row.waysObtain == 3" type="success">
            活动赠送券
          </el-tag>
          <el-tag v-else-if="scope.row.waysObtain == 4" type="success"
            >折扣券</el-tag
          >
          <el-tag v-else-if="scope.row.waysObtain == 5" type="success"
            >品类券</el-tag
          >
          <el-tag v-else-if="scope.row.waysObtain == 6" type="success"
            >单品券</el-tag
          >
          <el-tag v-else-if="scope.row.waysObtain == 7" type="success">
            邀新并下单
          </el-tag>
          <el-tag v-else-if="scope.row.waysObtain == 8" type="success">
            积分兑换
          </el-tag>
          <el-tag v-else-if="scope.row.waysObtain == 9" type="success">
            邀新并注册
          </el-tag>
          <el-tag v-else-if="scope.row.waysObtain == 10" type="success">
            多品券
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型" prop="rulesType" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 2" type="warning">满减</el-tag>
          <el-tag v-if="scope.row.type === 1" type="success">无门槛</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="获得方式"
        prop="releaseMode"
        width="100"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.releaseMode === 1" type="success"
            >自动发放</el-tag
          >
          <el-tag v-if="scope.row.releaseMode === 2" type="warning"
            >用户领取</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="是否可叠加"
        prop="releaseMode"
        width="100"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isSuperposition === 1" type="success"
            >是</el-tag
          >
          <el-tag v-if="scope.row.isSuperposition === 0" type="danger"
            >否</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="券总数"
        prop="allNum"
        width="100"
      />
      <el-table-column align="center" label="券剩余数" prop="num" width="100" />
      <el-table-column
        align="center"
        label="起始时间"
        prop="startTime"
        width="160"
      ></el-table-column>
      <el-table-column
        align="center"
        label="有效天数"
        prop="validTime"
        width="100"
      ></el-table-column>
      <el-table-column align="center" label="折扣" prop="discount" width="240">
        <template slot-scope="{ row }">
          <div v-if="row.waysObtain == 4">
            折扣率：{{ row.discount }} <br />满足件数：{{ row.discountNum }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="满足金额"
        prop="satisfyAmount"
        width="160"
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="优惠金额"
        prop="discountAmount"
        width="160"
      >
        <template slot-scope="{ row }">
          <span v-if="row.waysObtainMoney"
            >满{{ row.waysObtainMoney || "" }}元减{{
              row.discountAmount
            }}元</span
          >
          <span v-else>{{ row.discountAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="产品名称"
        prop="commodityName"
        width="300"
      >
        <template slot-scope="{ row }">
          <div
            v-if="
              row.couponSheetCommodityVos &&
              row.couponSheetCommodityVos.length > 0
            "
          >
            <div
              v-for="(item, index) in row.couponSheetCommodityVos"
              :key="index"
              style="cursor: pointer"
              @click="handleClick(row)"
            >
              <div v-if="index < 2">{{ item.commodityName }}</div>
            </div>
          </div>

          <div v-if="row.commodityName">
            {{ row.commodityName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="产品分类"
        prop="discount"
        width="120"
      >
        <template slot-scope="{ row }">
          <div v-if="row.waysObtain == 5">
            {{ row.classifyFirstName }}/{{ row.classifyName }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="创建时间"
        prop="createTime"
        width="200"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" prop="icon" width="260">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.state == 0 && hasAuth('sys:coupons:qiyong')"
            plain
            type="primary"
            @click="dateCouponsButton(scope.row.id)"
          >
            上架
          </el-button>
          <el-button
            v-if="scope.row.state == 1 && hasAuth('sys:coupons:jingyong')"
            plain
            type="danger"
            @click="dateCouponsButton(scope.row.id)"
          >
            下架
          </el-button>

          <el-button
            v-if="scope.row.isNew == 1"
            plain
            type="success"
            @click="addUpdateCouponsButton(scope.row)"
          >
            编辑
          </el-button>

          <el-button
            slot="reference"
            plain
            type="danger"
            v-if="hasAuth('sys:coupons:del') && scope.row.state != 1"
            @click="delHandle(scope.row.id)"
            >删除</el-button
          >

          <el-button
            v-if="scope.row.state == 1"
            plain
            type="primary"
            @click="sendfafang(scope.row)"
            >发放记录
          </el-button>
          <el-button
            v-if="
              scope.row.state == 1 &&
              scope.row.waysObtain == 3 &&
              scope.row.releaseMode == 1 &&
              hasAuth('sys:coupons:zengsong')
            "
            plain
            type="primary"
            @click="sendall(scope.row)"
            >赠送
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page="current"
      :page-size="size"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>

    <el-dialog title="产品" :visible.sync="dialogVisible" width="30%">
      <el-table
        :data="infoDetails.couponSheetCommodityVos"
        style="width: 100%"
        border
      >
        <el-table-column
          align="center"
          label="产品ID"
          prop="commodityId"
          width="200"
        >
        </el-table-column>
        <el-table-column align="center" label="产品名称" prop="commodityName">
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :visible.sync="showpons"
      title="确定给所有人发送此优惠券吗？一但发送无法撤回!"
      width="70%"
      top="30px"
    >
      <el-form>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="赠送人数" label-width="100px">
              <el-select
                v-model="type"
                clearable
                placeholder="赠送人数"
                style="width: 100%"
              >
                <el-option label="赠送个人" value="2"></el-option>
                <el-option label="赠送所有人" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赠送数量" label-width="100px">
              <el-input
                style="width: 100%"
                v-model="copnum"
                clearable
                placeholder="请输入数量"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="getfome()">确定赠送</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-divider></el-divider>
      <div v-if="type == 2">
        <el-form :inline="true">
          <el-form-item label="用户昵称" label-width="80px">
            <el-input
              v-model="name"
              clearable
              placeholder="用户昵称"
              @keyup.enter.native="getStoreGoods(1)"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="手机号" label-width="80px">
            <el-input
              v-model="phone"
              clearable
              placeholder="手机号"
              @keyup.enter.native="getStoreGoods(1)"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="getStoreGoods(1)">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="multipleTable"
          :data="tableDatas"
          border
          stripe
          style="width: 100%"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            align="center"
            label="用户昵称"
            prop="nickName"
          ></el-table-column>
          <el-table-column
            align="center"
            label="用户手机号"
            prop="phone"
          ></el-table-column>
          <el-table-column
            align="center"
            label="注册时间"
            prop="createTime"
          ></el-table-column>
          <el-table-column
            align="center"
            label="操作"
            prop="icon"
            width="140px"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.userId == selectId"
                plain
                type="success"
                @click="selsctButton(scope.row.userId)"
              >
                已选择
              </el-button>
              <el-button
                v-else
                plain
                type="warning"
                @click="selsctButton(scope.row.userId)"
              >
                选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="currents"
          :page-size="sizes"
          :page-sizes="[10, 20, 50, 100]"
          :total="totals"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChanges"
          @current-change="handleCurrentChanges"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <AddUpdateCoupons
      v-if="addUpdateCouponsvisible"
      ref="addUpdateCoupons"
      @refreshDataList="getCoupons"
    >
    </AddUpdateCoupons>
    <SelectUsers
      v-if="getCouponsUserssvisible"
      ref="getCouponsUsers"
      @refreshDataList="getUsersList(scope.row.couponsId)"
    ></SelectUsers>
    <fafang ref="visfa" />
  </div>
</template>

<script>
import AddUpdateCoupons from "./AddUpdateCoupons";
import SelectUsers from "./SelectUsers";
import fafang from "./fafang.vue";
import axios from "axios";
import ty from "../../utils/ty";
import { get } from "jquery";
export default {
  name: "Coupons",
  components: {
    AddUpdateCoupons,
    SelectUsers,
    fafang,
  },
  data() {
    return {
      dialogVisible: false,
      infoDetails: {},
      searchForm: {},
      delBtlStatu: true,
      tableData: [],
      tableDatas: [],
      multipleSelection: [],
      calcHeight: 0,
      total: 0,
      size: 10,
      configNum: 0,
      current: 1,
      totals: 0,
      sizes: 10,
      currents: 1,
      addUpdateCouponsvisible: false,
      getCouponsUserssvisible: false,
      showpons: false,
      copnum: 1,
      type: "2",
      id: "",
      template: "",
      phone: "",
      name: "",
      selectId: "",
      uploadUrl: ty.apiurl + "/admin/sysCouponSheet/batchIssueByExcel",
      uploadHeaders: {
        Authorization: "",
      },
    };
  },
  created() {
    this.calcHeight = window.innerHeight - 250;
    this.getCoupons();
    this.getuser();
    this.delConfig();
    this.getToken();
  },
  methods: {
    handleClick(item) {
      this.infoDetails = JSON.parse(JSON.stringify(item));
      console.log(this.infoDetails);
      this.dialogVisible = true;
    },
    getToken() {
      var token = sessionStorage.getItem("token");
      if (token) {
        var items = [
          { pos: token.length - 1, str: "AGhdGAUE6Y" },
          { pos: 38, str: "V22" },
          { pos: 26, str: "Sy" },
          { pos: 18, str: "Hi" },
          { pos: 10, str: "Ti" },
          { pos: 1, str: "Ai" },
        ];
        for (let item of items) {
          if (
            token.substring(item.pos, item.pos + item.str.length) === item.str
          ) {
            token =
              token.substring(0, item.pos) +
              token.substring(item.pos + item.str.length);
          } else {
            const idx = token.indexOf(item.str);
            if (idx !== -1)
              token =
                token.substring(0, idx) +
                token.substring(idx + item.str.length);
          }
        }
      }
      this.uploadHeaders.Authorization = token;
    },

    beforeUpload(file) {
      const isExcel =
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isExcel) {
        this.$message.error("只能上传 Excel 文件!");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("文件大小不能超过 10MB!");
        return false;
      }
      return true;
    },

    handleUploadSuccess(response, file) {
      if (response.code === 0) {
        this.$message({
          message: "导入成功",
          type: "success",
        });
        this.getCoupons();
      } else {
        this.$message.error(response.msg || "导入失败");
      }
    },

    handleUploadError(error, file) {
      this.$message.error("上传失败，请重试");
      console.error("上传错误:", error);
    },

    exportCouponsTemplate() {
      axios({
        method: "get",
        url: ty.apiurl + "/admin/sysCouponSheet/exportTemplate",
        headers: {
          Authorization: this.uploadHeaders.Authorization,
        },
        responseType: "blob",
      })
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", "优惠卷模板.xlsx");
          link.click();
          link = null;
        })
        .catch((error) => {});
    },

    sendfafang(row) {
      this.$refs.visfa.init(row);
    },
    getStoreGoods(e) {
      this.currents = 1;
      this.getuser();
    },
    selsctButton(e) {
      if (e == this.selectId) {
        this.selectId = "";
      } else {
        this.selectId = e;
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getCoupons();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getCoupons();
    },
    handleSizeChanges(val) {
      this.sizes = val;
      this.getuser();
    },
    handleCurrentChanges(val) {
      this.currents = val;
      this.getuser();
    },
    getuser() {
      this.$axios
        .post("/admin/userBase/getUserList", {
          pageNo: this.currents,
          pageSize: this.sizes,
          phone: this.phone,
          name: this.name,
        })
        .then((res) => {
          this.tableDatas = res.data.records;
          this.sizes = res.data.size;
          this.currents = res.data.current;
          this.totals = res.data.total;
        });
    },
    //获取资讯列表
    getCoupons() {
      var startTimes = "";
      var endTimes = "";
      if (this.searchForm.createTime != undefined) {
        startTimes = this.searchForm.createTime[0];
        endTimes = this.searchForm.createTime[1];
      }
      this.searchForm.startTimes = startTimes;
      this.searchForm.endTimes = endTimes;
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.$axios
        .post("/admin/sysCouponSheet/getList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
    //选择用户
    getUsersList(couponsId) {
      this.getCouponsUserssvisible = true;
      this.$nextTick(() => {
        this.$refs.getCouponsUsers.init(couponsId);
      });
    },
    deCouponsButton(id) {},
    getfome() {
      if (this.type == 1) {
        this.$axios
          .post("/admin/sysCouponSheet/issueCoupon", {
            couponsId: this.id,
            number: this.copnum,
            type: this.type,
          })
          .then((res) => {
            this.getCoupons();
            this.showpons = false;
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      } else {
        this.$axios
          .post("/admin/sysCouponSheet/issueCoupon", {
            couponsId: this.id,
            number: this.copnum,
            type: this.type,
            userId: this.selectId,
          })
          .then((res) => {
            this.getCoupons();
            this.showpons = false;
            this.selectId = "";
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      }
    },
    sendall(e) {
      this.id = e.id;
      this.showpons = true;
    },
    handleClose() {
      this.showpons = false;
    },
    dateCouponsButton(id) {
      this.$axios
        .post("/admin/sysCouponSheet/updateState", {
          id: id,
        })
        .then((res) => {
          this.getCoupons();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },
    //删除资讯
    delHandle(id) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/sysCouponSheet/del", {
            id: id,
          })
          .then((res) => {
            this.getCoupons();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      });
    },
    delConfig() {
      this.$axios.post("/admin/sysCouponSheet/getCouponConfig").then((res) => {
        this.configNum = res.data;
      });
    },
    CouponsSetting() {
      var _this = this;
      _this
        .$prompt(
          "请输入可叠加优惠券数量",
          `温馨提示：当前配置可叠加优惠券数量为：${_this.configNum}`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
        .then(({ value }) => {
          _this.$axios
            .post("/admin/sysCouponSheet/couponConfig", {
              num: value,
            })
            .then((res) => {
              _this.$message({
                showClose: true,
                message: "提交成功",
                type: "success",
                onClose: () => {},
              });
              _this.delConfig();
            });
        })
        .catch(() => {});
    },

    //下架、上架商城商品
    updCouponsIsOnframe(model) {
      this.$confirm(
        "操作需谨慎：此操作将是该优惠券" +
          (model.isOnframe === 0 ? "下架" : "上架") +
          "，是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios
          .post("/admin/coupons/updCouponsIsOnframe", {
            couponsId: model.couponsId,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
              onClose: () => {
                this.getCoupons();
              },
            });
          });
      });
    },
    addUpdateCouponsButton(row) {
      this.addUpdateCouponsvisible = true;
      this.$nextTick(() => {
        this.$refs.addUpdateCoupons.init(row);
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>